/* eslint-disable func-style */
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
} from "@ionic/react";

import { useSubscriptionFees } from "@/hooks/useSubscriptionFees";
import { createNavigationProps } from "@/utils/common";
import { GET_STARTED_MENU_ITEM } from "@/utils/constants/menu";
import { FeatureAccessLevel } from "@/utils/constants/subscriptions";

import { FeatureItems } from "./PricingFeatureList";
import { BASIC_FEATURES } from "./pricingFeatures";

export const BasicSubscriptionPricing: React.FC = () => {
  const {
    data: subscriptionFees,
    isError: _isError,
    isLoading: _isLoading,
  } = useSubscriptionFees();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const fee = subscriptionFees?.fees[FeatureAccessLevel.TRIAL];

  // Fallback to default pricing if API fails
  const displayPrice = (() =>
    // FIX: MFP Requested no basic price
    "Free")();
  // if (isLoading) {
  //   return "Loading...";
  // }
  // if (isError || isUndefined(fee)) {
  //   return "$129.00";
  // } // Fallback to known default
  // return fee === 0 ? "Free" : formatCentsToDollars(fee);

  return (
    <IonCard className="base">
      <IonCardHeader>
        <IonCardTitle className="title-pricing-base">Basic </IonCardTitle>
        <IonCardSubtitle className="sub">
          {displayPrice} - Upgrade any time!
        </IonCardSubtitle>
      </IonCardHeader>

      <IonCardContent>
        <FeatureItems items={BASIC_FEATURES} />
        <IonButton
          className="pricing-cta"
          fill="outline"
          {...createNavigationProps(GET_STARTED_MENU_ITEM.linkTo)}
        >
          Get Started
        </IonButton>
      </IonCardContent>
    </IonCard>
  );
};
